import type { IconProps } from '.';

/**
 * Download Icon SVG component.
 *
 * IMPORTANT:
 * Importing a SVG directly tells the compiler to use Webpack, thus including the whole file in the bundle.
 * By using a component instead, we can leverage server components and return HTML directly from the server.
 */

const DownloadIcon = ({ className }: IconProps) => (
  <svg
    role="presentation"
    aria-hidden="true"
    focusable="false"
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    className={className}
  >
    <path d="M8.00004 16H16V17H8.00004V16Z" fill="white" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.5 12.7929L15.6465 9.64645L16.3536 10.3536L12 14.7071L7.64648 10.3536L8.35359 9.64645L11.5 12.7929L11.5 6L12.5 6V12.7929Z"
      fill="white"
    />
  </svg>
);

export default DownloadIcon;
